import React, { Component } from 'react';
import { nextStage } from '../../../actions/purchaseActions';
import { connect } from 'react-redux';
// import { validatePurchaseMobile } from '../../../utils'

class ButtonStage extends Component {
  render() {
    const onButtonClick = () => {
      window.scrollTo({
        top: 0
      });

      this.props.stepPaymentFinish
        ? this.props.nextStage(4, this.props.stage)
        : this.props.nextStage(this.props.index, this.props.stage);
    };

    return (
      <button className="button-stage" data-cy={this.props['data-cy']} onClick={onButtonClick}>
        Continuar
      </button>
    );
  }
}

export default connect(
  (state) => ({
    paymentMethods: state.purchase.paymentMethods,
    stepPaymentFinish: state.purchase.stepPaymentFinish,
  }),
  {
    nextStage,
  }
)(ButtonStage);



// WEBPACK FOOTER //
// ./src/components/standard/button_stage/ButtonStage.jsx